import { render, staticRenderFns } from "./ReportItem.vue?vue&type=template&id=67a9aac2"
import script from "./ReportItem.vue?vue&type=script&lang=js"
export * from "./ReportItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports